// src/Footer.js
import React from 'react';
import Logo from './assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <h3 className="text-2xl font-bold mb-4">Wentago</h3>
            <p className="text-gray-400 mb-4">
              We build smart web tools that streamline your daily browser actions.
            </p>
            <div className="flex space-x-4">
              <img
                src={Logo}
                alt="Wentago Logo"
                className="w-12 h-12 object-contain transition-transform duration-300 hover:scale-110"
              />
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="text-gray-400 space-y-2">
              <li>kontakt@wentago.pl</li>
              <li>Wentago</li>
              <li>15-773 Białystok</li>
              <li>Poland</li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Policies & Links</h4>
            <ul className="text-gray-400 space-y-2">
              <li><a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/return-policy" className="hover:text-white transition-colors">Return Policy</a></li>
              <li><a href="/terms" className="hover:text-white transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Wentago. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
